export default function XML_Tree() {
  return (
    <div>
      <h1>XML_Tree</h1>
      <p>This is the XML_Tree component.</p>
    </div>
  );
}